import { createValidIcon } from '@ui/icons/utils/type-helper'

export const GlobeIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.06189 11H7.02328C7.12643 8.79597 7.56798 6.78191 8.25776 5.2299C8.31802 5.09431 8.38064 4.96122 8.44561 4.83099C6.09485 5.99874 4.39999 8.2887 4.06189 11ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM12 4C11.7731 4 11.4816 4.0993 11.1324 4.43166C10.778 4.76892 10.4134 5.30422 10.0854 6.04218C9.52392 7.30546 9.12736 9.03347 9.02567 11H14.9743C14.8726 9.03347 14.4761 7.30546 13.9146 6.04218C13.5866 5.30422 13.222 4.76892 12.8676 4.43166C12.5184 4.0993 12.2269 4 12 4ZM16.9767 11C16.8736 8.79597 16.432 6.78191 15.7422 5.2299C15.682 5.09431 15.6194 4.96122 15.5544 4.83099C17.9052 5.99874 19.6 8.2887 19.9381 11H16.9767ZM14.9743 13H9.02567C9.12736 14.9665 9.52392 16.6945 10.0854 17.9578C10.4134 18.6958 10.778 19.2311 11.1324 19.5683C11.4816 19.9007 11.7731 20 12 20C12.2269 20 12.5184 19.9007 12.8676 19.5683C13.222 19.2311 13.5866 18.6958 13.9146 17.9578C14.4761 16.6945 14.8726 14.9665 14.9743 13ZM15.5544 19.169C15.6194 19.0388 15.682 18.9057 15.7422 18.7701C16.432 17.2181 16.8736 15.204 16.9767 13H19.9381C19.6 15.7113 17.9052 18.0013 15.5544 19.169ZM8.44561 19.169C8.38064 19.0388 8.31802 18.9057 8.25776 18.7701C7.56798 17.2181 7.12643 15.204 7.02328 13H4.06189C4.39999 15.7113 6.09485 18.0013 8.44561 19.169Z'
        fill={color}
      />
    </svg>
  )
})
